import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../../components/Admin/Dropzone";

import { Container, Content, Title, Image, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { systemLogs } from "../../../../../services/system_logs";

const EditarTreinamento = (props) => {
  //---------UseRef-----------
  const objetivo = useRef("");
  const publico = useRef("");
  const preDetalhe = useRef("");
  const detalhe = useRef("");
  const combo = useRef("");
  const posTreinamento = useRef("");
  const recapitulando = useRef("");
  const beneficios = useRef("");
  const extra = useRef("");
  const versoCertificado = useRef("");
  const detalheAssuntoA = useRef("");
  const detalheAssuntoB = useRef("");
  const detalheAssuntoC = useRef("");
  const detalheAssuntoD = useRef("");
  //------------------------------------
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [iconFiles, setIconFiles] = useState([
    undefined,
    undefined,
    undefined,
    undefined,
  ]);
  const [assuntos, setAssuntos] = useState(["", "", "", ""]);
  const [assuntosConteudo, setAssuntosConteudo] = useState(["", "", "", ""]);
  const [area, setArea] = useState([]);
  const [treinamento, setTreinamento] = useState({});
  const id = props.match.params.id;
  const [imagem, setImagem] = useState("");

  const optionsTipo = [
    { id: 1, text: "PRESENCIAL" },
    { id: 2, text: "MINI CURSO" },
    { id: 3, text: "ONLINE" },
    { id: 4, text: "EVENTOS" },
    { id: 5, text: "PALESTRAS" },
    { id: 6, text: "AO VIVO" },
    { id: 7, text: "LET'S GROW" },
    { id: 8, text: "POWER HACKS" },
    { id: 9, text: "NA PRÁTICA" },
    { id: 10, text: "PAPO DE ESPECIALISTA" },
    { id: 11, text: "MASTER CLASS" },
    { id: 12, text: "WEBSÉRIE" },
    { id: 13, text: "EVENTO" },
    { id: 14, text: "WORKSHOP" },
    { id: 15, text: "CICLO DE MENTORIA" }
  ];

  useEffect(() => {
    setLoading(true);
    loadAuth();
    loadTreinamento();
    loadArea();
    loadDetalhes();
  }, []);

  const loadDetalhes = async () => {
    detalheAssuntoA.current = assuntosConteudo[0];
    detalheAssuntoB.current = assuntosConteudo[1];
    detalheAssuntoC.current = assuntosConteudo[2];
    detalheAssuntoD.current = assuntosConteudo[3];
  };

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadArea = async () => {
    await api
      .get(`area`)
      .then((res) => {
        setArea(res.data);
      })
      .catch((err) => {
        swal("Não foi possível carregar as areas", err, "error");
      });
  };

  const loadTreinamento = async () => {
    await api
      .get(`/admin/treinamentos/${id}`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then(async (res) => {
        await systemLogs(
          "curso/conteudo",
          `listou o treinamento de id=${res.data.id}`
        );

        setTreinamento(res.data);
        setImagem(
          `https://files.voitto.com.br/ftp-files/images/cursos/ico/${id}.jpg`
        );
        setAssuntos(res.data.assuntos.split(";"));
        setAssuntosConteudo(res.data.assuntos_conteudo.split(";({[SEPARATOR]});"));
      })
      .catch((err) => {
        swal("Não foi possível carregar o treinamento", err, "error");
      });
    setLoading(false);
  };

  const update = async () => {
    let detalhes;
    detalhes = await manipulateContent(detalheAssuntoA.current, 'assunto_conteudo', 0);
    detalhes = await manipulateContent(detalheAssuntoB.current, 'assunto_conteudo', 1);
    detalhes = await manipulateContent(detalheAssuntoC.current, 'assunto_conteudo', 2);
    detalhes = await manipulateContent(detalheAssuntoD.current, 'assunto_conteudo', 3);

    const payload = {
      id_area: treinamento.id_area,
      tipo: treinamento.tipo,
      nome: treinamento.nome,
      slogan: treinamento.slogan,
      sobre: objetivo.current,
      alvo: posTreinamento.current,
      prerequisitos: publico.current,
      visao: detalhe.current,
      combo: combo.current,
      certificado: versoCertificado.current,
      recapitulando: recapitulando.current,
      valor: beneficios.current,
      extra: extra.current,
      video: treinamento.video,
      predetalhamento: preDetalhe.current,
      ativo: treinamento.ativo,
      video1: treinamento.video1,
      video2: treinamento.video2,
      video3: treinamento.video3,
      video4: treinamento.video4,
      ordem: treinamento.ordem,
      link: treinamento.link,
      link_externo: treinamento.link_externo,
      style_extra: treinamento.style_extra,
      js_extra: treinamento.js_extra,
      texto_botao: treinamento.texto_botao,
      cor: treinamento.cor,
      topico1: treinamento.topico1 || "",
      topico2: treinamento.topico2 || "",
      topico3: treinamento.topico3 || "",
      nome_title: treinamento.nome_title,
      icones: treinamento.icones,
      assuntos: treinamento.assuntos,
      assuntos_conteudo: detalhes,
    };

    const treinamentoValidation = await yup.object().shape({
      id_area: yup
        .string("Necessário que informe a area")
        .required("Necessário que informe a area"),
      tipo: yup
        .string("Necessário que informe o tipo")
        .required("Necessário que informe o tipo"),
      nome: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      slogan: yup
        .string("Necessário que informe o slogan")
        .required("Necessário que informe o slogan"),
      nome_title: yup
        .string("Necessário que informe o title da pagina")
        .required("Necessário que informe o title da pagina"),
      video: yup
        .string("Necessário que informe o video")
        .required("Necessário que informe o video"),
    });

    try {
      await treinamentoValidation.validate(payload, { abortEarly: true });

      if (
        treinamento.tipo === "12" ||
        treinamento.tipo === 12 ||
        treinamento.tipo === "13" ||
        treinamento.tipo === 13 ||
        treinamento.tipo === "14" ||
        treinamento.tipo === 14 ||
        treinamento.tipo === "15" ||
        treinamento.tipo === 15
      ) {
        const iconsArray = await uploadIcons();
        payload.icones = iconsArray.join(";");
      }

      await api
        .put(`/admin/treinamentos/${id}`, payload,{
          headers: {
            access_token: `voitto-token ${localStorage.getItem(
              'oauth_token'
            )}`
          }
        })
        .then(async () => {
          if (selectedFile != "") {
            await uploadImage(id);
          }
          let logs = {
            local: "curso/conteudo",
            texto: `editou um treinamento de id=${id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Treinamento atualizado com sucesso", "", "success").then(() =>
            props.history.push("/admin/cursos/conteudo")
          );
        })
        .catch((err) => {
          swal("Não foi possível atualizar o treinamento", err, "").then(() =>
            props.history.push("/admin/cursos/conteudo")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  const manipulateContent = async (content, field, index) => {
    switch (field) {
      case "assunto":
        if (assuntos !== null && assuntos !== undefined) {
          const assuntosArray = assuntos;
          assuntosArray[index] = content;
          setAssuntos(assuntosArray);
        }
        break;
      case "assunto_conteudo":
        if (assuntosConteudo !== null && assuntosConteudo !== undefined) {
          const assuntosConteudoArray = assuntosConteudo;
          assuntosConteudoArray[index] = content;
          setAssuntosConteudo(assuntosConteudoArray);
        }
        break;
      default:
        swal(
          "Ocorreu um erro!",
          "Houve um erro no processamento dessa funcionalidade, tente novamente.",
          "error"
        );
        break;
    }

    if (field === "assunto") {
      setTreinamento({ ...treinamento, assuntos: assuntos.join(";") });
    }

    if (field === "assunto_conteudo") {
      return assuntosConteudo.join(";({[SEPARATOR]});");
    }
  };

  const manipulateFiles = async (file, index) => {
    const iconsArray = iconFiles;
    iconsArray[index] = file;
    setIconFiles(iconsArray);
  };

  const uploadIcons = async () => {
    if (
      treinamento.tipo !== "12" &&
      treinamento.tipo !== 12 &&
      treinamento.tipo !== "13" &&
      treinamento.tipo !== 13 &&
      treinamento.tipo !== "14" &&
      treinamento.tipo !== 14 &&
      treinamento.tipo !== "15" &&
      treinamento.tipo !== 15
    ) {
      return;
    }

    let directory = "";

    const foundDirectory = parseInt(treinamento.tipo);

    switch (foundDirectory) {
      case 12:
        directory = "Digital/Webseries/Icones";
        break;
      case 13:
        directory = "Digital/Eventos/Icones";
        break;
      case 14:
        directory = "Digital/Workshops/Icones";
        break;
      case 15:
        directory = "Digital/CiclosMentoria/Icones";
        break;
      default:
        directory = "Digital/Icones";
        break;
    }

    let actualFiles = [undefined, undefined, undefined, undefined];

    if (treinamento.icones) {
      actualFiles = treinamento.icones.split(";");
    }

    const filesArray = Object.values(iconFiles);

    const filesUrls = await Promise.all(
      filesArray.map(async (file, index) => {
        if (file) {
          const filesData = new FormData();

          filesData.append("file", file);
          filesData.append("path", directory);

          const fileUrl = await api
            .post(`/upload`, filesData)
            .then((res) => res.data.url)
            .catch((err) => {
              console.error(err);
              return null;
            });

          return fileUrl;
        } else {
          return actualFiles[index];
        }
      })
    );

    return filesUrls;
  };

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", `ftp-files/images/cursos/ico`);
      inputData.append("nome", `${id}`);

      await api.post(`/upload`, inputData).then((res) => {
        setImagem(res.data.url);
      });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const ImageError = () => {
    setImagem((self) => self.replace("jpg", "png"));
  };

  const loadPage = () => {
    return (
      <>
        <Container>
          <AdminMenu />
          <Content>
            <Title>Editar Treinamento</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Tipo</Label>
                  <select
                    value={treinamento.tipo}
                    onChange={(e) =>
                      setTreinamento({ ...treinamento, tipo: e.target.value })
                    }
                  >
                    {optionsTipo.map((tipo) => (
                      <option value={tipo.id}>{tipo.text}</option>
                    ))}
                  </select>
                </Form.Field>
                {/* <Form.Field>
                  <Label>Área</Label>
                  <select
                    value={treinamento.id_area}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        id_area: e.target.value,
                      })
                    }
                  >
                    {area.map((are) => (
                      <option value={are.id}>{are.nome}</option>
                    ))}
                  </select>
                </Form.Field> */}
              </Form.Group>
              {(treinamento.tipo === "12" ||
                treinamento.tipo === 12 ||
                treinamento.tipo === "13" ||
                treinamento.tipo === 13 ||
                treinamento.tipo === "14" ||
                treinamento.tipo === 14 ||
                treinamento.tipo === "15" ||
                treinamento.tipo === 15) && (
                  <>
                    <h2>Detalhes da página de vendas</h2>
                    <span style={{ paddingBottom: "20px" }}>
                      <p>
                        Imagens em .png, .jpg ou .jpeg
                        <br />
                        (Tamanho recomendado: 100x100)
                      </p>
                    </span>
                    <Form.Group widths="equal">
                      <Form.Field>
                        <Label>Ícone da página de vendas</Label>
                        <input
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => {
                            manipulateFiles(e.target.files[0], 0);
                          }}
                        />
                        {treinamento.icones ? (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={treinamento.icones.split(";")[0]}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        ) : (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={"/NoImage"}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        )}
                      </Form.Field>
                      <div className="assuntoWebserie">
                        {treinamento.assuntos ? (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value={
                              assuntos[0]
                                ? assuntos[0]
                                : treinamento.assuntos.split(";")[0]
                            }
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 0);
                            }}
                          />
                        ) : (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value=""
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 0);
                            }}
                          />
                        )}

                        {treinamento.assuntos_conteudo ? (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoA.current !== "" ? detalheAssuntoA.current : treinamento.assuntos_conteudo.split(";({[SEPARATOR]});")[0]}
                              text={detalheAssuntoA}
                            />
                          </Form.Field>
                        ) : (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoA.current}
                              text={detalheAssuntoA}
                            />
                          </Form.Field>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group widths="equal">
                      <Form.Field>
                        <Label>Ícone da página de vendas</Label>
                        <input
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => {
                            manipulateFiles(e.target.files[0], 1);
                          }}
                        />
                        {treinamento.icones ? (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={treinamento.icones.split(";")[1]}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        ) : (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={"/NoImage"}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        )}
                      </Form.Field>
                      <div className="assuntoWebserie">
                        {treinamento.assuntos ? (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value={
                              assuntos[1]
                                ? assuntos[1]
                                : treinamento.assuntos.split(";")[1]
                            }
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 1);
                            }}
                          />
                        ) : (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value=""
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 1);
                            }}
                          />
                        )}

                        {treinamento.assuntos_conteudo ? (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoB.current !== "" ? detalheAssuntoB.current : treinamento.assuntos_conteudo.split(";({[SEPARATOR]});")[1]}
                              text={detalheAssuntoB}
                            />
                          </Form.Field>
                        ) : (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoB.current}
                              text={detalheAssuntoB}
                            />
                          </Form.Field>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group widths="equal">
                      <Form.Field>
                        <Label>Ícone da página de vendas</Label>
                        <input
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => {
                            manipulateFiles(e.target.files[0], 2);
                          }}
                        />

                        {treinamento.icones ? (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={treinamento.icones.split(";")[2]}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        ) : (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={"/NoImage"}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        )}
                      </Form.Field>

                      <div className="assuntoWebserie">
                        {treinamento.assuntos ? (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value={
                              assuntos[2]
                                ? assuntos[2]
                                : treinamento.assuntos.split(";")[2]
                            }
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 2);
                            }}
                          />
                        ) : (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value=""
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 2);
                            }}
                          />
                        )}

                        {treinamento.assuntos_conteudo ? (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoC.current !== "" ? detalheAssuntoC.current : treinamento.assuntos_conteudo.split(";({[SEPARATOR]});")[2]}
                              text={detalheAssuntoC}
                            />
                          </Form.Field>
                        ) : (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoC.current}
                              text={detalheAssuntoC}
                            />
                          </Form.Field>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group widths="equal">
                      <Form.Field>
                        <Label>Ícone da página de vendas</Label>
                        <input
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={(e) => {
                            manipulateFiles(e.target.files[0], 3);
                          }}
                        />

                        {treinamento.icones ? (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={treinamento.icones.split(";")[3]}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        ) : (
                          <>
                            <Label>Ícone atual</Label>
                            <Image
                              src={"/NoImage"}
                              alt="Ícone 1"
                              width="100px"
                              height="100px"
                            />
                          </>
                        )}
                      </Form.Field>

                      <div className="assuntoWebserie">
                        {treinamento.assuntos ? (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value={
                              assuntos[3]
                                ? assuntos[3]
                                : treinamento.assuntos.split(";")[3]
                            }
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 3);
                            }}
                          />
                        ) : (
                          <Form.Field
                            control={Input}
                            label="Assunto"
                            placeholder=""
                            value=""
                            onChange={(e) => {
                              manipulateContent(e.target.value, "assunto", 3);
                            }}
                          />
                        )}

                        {treinamento.assuntos_conteudo ? (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoD.current !== "" ? detalheAssuntoD.current : treinamento.assuntos_conteudo.split(";({[SEPARATOR]});")[3]}
                              text={detalheAssuntoD}
                            />
                          </Form.Field>
                        ) : (
                          <Form.Field>
                            <Label>Detalhamento do assunto</Label>
                            <TextEditor
                              haveFullscreen
                              default={detalheAssuntoD.current}
                              text={detalheAssuntoD}
                            />
                          </Form.Field>
                        )}
                      </div>
                    </Form.Group>
                  </>
                )}
              <h2>Conteúdo da Página</h2>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Titulo"
                  placeholder="Titulo"
                  value={treinamento.nome}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, nome: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Title da Pagina"
                  placeholder="titulo da pagina"
                  value={treinamento.nome_title}
                  onChange={(e) => {
                    setTreinamento({
                      ...treinamento,
                      nome_title: e.target.value,
                    });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Slogan</Label>
                  <textarea
                    rows="2"
                    value={treinamento.slogan}
                    onChange={(e) =>
                      setTreinamento({ ...treinamento, slogan: e.target.value })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Tópico 1</Label>
                  <textarea
                    rows="2"
                    value={treinamento.topico1}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        topico1: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Tópico 2</Label>
                  <textarea
                    rows="2"
                    value={treinamento.topico2}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        topico2: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Tópico 3</Label>
                  <textarea
                    rows="2"
                    value={treinamento.topico3}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        topico3: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Texto Botão de Compra"
                  placeholder="Texto Botão de Compra"
                  value={treinamento.texto_botao}
                  onChange={(e) => {
                    setTreinamento({
                      ...treinamento,
                      texto_botao: e.target.value,
                    });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="URL Externa (Ir para url externa)"
                  placeholder="URL Externa"
                  value={treinamento.link}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, link: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Video</Label>
                  <textarea
                    value={treinamento.video}
                    onChange={(e) =>
                      setTreinamento({ ...treinamento, video: e.target.value })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Qual o objetivo desse treinamento:</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.sobre}
                    text={objetivo}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Público alvo (Este treinamento é pra mim)</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.prerequisitos}
                    text={publico}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Pré detalhamento</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.predetalhamento}
                    text={preDetalhe}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>
                    Detalhamento (Como este treinamento é estruturado)
                  </Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.visao}
                    text={detalhe}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Combo</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.combo}
                    text={combo}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>
                    O que serei capaz de fazer depois desse treinamento
                  </Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.alvo}
                    text={posTreinamento}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Recapitulando</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.recapitulando}
                    text={recapitulando}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Área de Benefícios</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.valor}
                    text={beneficios}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Aula Demonstrativa 1"
                  placeholder="Aula Demonstrativa 1"
                  value={treinamento.video1}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, video1: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Aula Demonstrativa 2"
                  placeholder="Aula Demonstrativa 2"
                  value={treinamento.video2}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, video2: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Aula Demonstrativa 3"
                  placeholder="Aula Demonstrativa 3"
                  value={treinamento.video3}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, video3: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Aula Demonstrativa 4"
                  placeholder="Aula Demonstrativa 4"
                  value={treinamento.video4}
                  onChange={(e) => {
                    setTreinamento({ ...treinamento, video4: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Extra</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.extra}
                    text={extra}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Css</Label>
                  <textarea
                    value={treinamento.style_extra}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        style_extra: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>JavaScript</Label>
                  <textarea
                    value={treinamento.js_extra}
                    onChange={(e) =>
                      setTreinamento({
                        ...treinamento,
                        js_extra: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <h2>Outros</h2>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Conteúdo Programático para Verso do Certificado</Label>
                  <TextEditor
                    haveFullscreen
                    default={treinamento.certificado}
                    text={versoCertificado}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Ícone Treinamento</Label>
                  <Dropzone onFileUploaded={setSelectedFile} />
                  <Image src={imagem} onError={() => ImageError()} />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal"></Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Cor de Fundo Página</Label>
                  <input
                    type="color"
                    value={treinamento.cor}
                    onChange={(e) =>
                      setTreinamento({ ...treinamento, cor: e.target.value })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Divider hidden />
              <Form.Group>
                <Form.Field
                  control={Button}
                  onClick={() => {
                    update();
                  }}
                >
                  Salvar
                </Form.Field>
                <Link to="/admin/cursos/conteudo">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        </Container>
      </>
    );
  };

  return loadPage();
};

export default withRouter(EditarTreinamento);
